import isBrowser from './is-browser';

// 모바일 에이전트 구분
export default {
  Android() {
    return isBrowser() ? window.navigator.userAgent.match(/Android/i) === null ? false : true : false;
  },
  BlackBerry() {
    return isBrowser() ? window.navigator.userAgent.match(/BlackBerry/i) === null ? false : true : false;
  },
  IOS() {
    return isBrowser() ? window.navigator.userAgent.match(/iPhone|iPad|iPod/i) === null ? false : true : false;
  },
  Opera() {
    return isBrowser() ? window.navigator.userAgent.match(/Opera Mini/i) === null ? false : true : false;
  },
  Windows() {
    return isBrowser() ? window.navigator.userAgent.match(/IEMobile/i) === null ? false : true : false;
  },
  any() {
    return (this.Android() || this.BlackBerry() || this.IOS() || this.Opera() || this.Windows());
  }
};
